import React from 'react';
import PropTypes from 'prop-types';

const DepartmentDropdownItem = ({ text }) => (
    <div className="department-dropdown-item">
        <span>{text}</span>
    </div>
);

DepartmentDropdownItem.propTypes = {
    text: PropTypes.string.isRequired,
};

export default DepartmentDropdownItem;
